'use strict';

var styled = require('styled-components');

/* stylelint-disable font-family-no-missing-generic-family-keyword */

/**
 * Mixin to apply the P22 Mackinac Medium font.
 */
var p22MackinacMediumMixin = styled.css(["font-family:'P22-Mackinac-Medium',Georgia,serif;font-weight:300;font-style:normal;font-stretch:normal;"]);

/**
 * Mixin to apply the P22 Mackinac Book font.
 */
var p22MackinacBookMixin = styled.css(["font-family:'P22-Mackinac-Book',Georgia,serif;font-weight:normal;font-style:normal;font-stretch:normal;"]);

/* stylelint-disable font-family-no-missing-generic-family-keyword */

/**
 * Mixin to apply the Aktiv Grotesk Bold font.
 */
var aktivGroteskBoldMixin = styled.css(["font-family:'Aktiv-Grotesk-Bold',Helvetica,sans-serif;font-weight:bold;font-style:normal;font-stretch:normal;"]);

/**
 * Mixin to apply the Aktiv Grotesk Medium font.
 */
var aktivGroteskMediumMixin = styled.css(["font-family:'Aktiv-Grotesk-Medium',Helvetica,sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;"]);

/**
 * Mixin to apply the Aktiv Grotesk Regular font.
 */
var aktivGroteskRegularMixin = styled.css(["font-family:'Aktiv-Grotesk-Regular',Helvetica,sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;"]);

/**
 * Mixin to apply the Aktiv Grotesk Italic font.
 */
var aktivGroteskItalicMixin = styled.css(["font-family:'Aktiv-Grotesk-Italic',Helvetica,sans-serif;font-weight:normal;font-style:normal;font-stretch:normal;"]);

/* stylelint-disable font-family-no-missing-generic-family-keyword */

/**
 * Mixin to apply the Monosten C font.
 */
var monostenCMixin = styled.css(["font-family:'Monosten','Courier-New',Courier,monospace;font-weight:normal;font-style:normal;font-stretch:normal;"]);

exports.aktivGroteskBoldMixin = aktivGroteskBoldMixin;
exports.aktivGroteskItalicMixin = aktivGroteskItalicMixin;
exports.aktivGroteskMediumMixin = aktivGroteskMediumMixin;
exports.aktivGroteskRegularMixin = aktivGroteskRegularMixin;
exports.monostenCMixin = monostenCMixin;
exports.p22MackinacBookMixin = p22MackinacBookMixin;
exports.p22MackinacMediumMixin = p22MackinacMediumMixin;
//# sourceMappingURL=monosten-d688040f.js.map
